import request from '@/utils/request';
export function getMenu() {
  return request({
    url: '/admin/system/role/testMenu',
    method: 'GET'
  });
}
export function adminDel(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/system/admin/delete',
    method: 'GET',
    params: data
  });
}
export function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/system/admin/info',
    method: 'GET',
    params: data
  });
}
export function adminList(params) {
  return request({
    url: '/admin/system/admin/list',
    method: 'GET',
    params: params
  });
}
export function adminAdd(pram) {
  var data = {
    account: pram.account,
    level: pram.level,
    pwd: pram.pwd,
    realName: pram.realName,
    roles: pram.roles.join(','),
    status: pram.status,
    phone: pram.phone
  };
  return request({
    url: '/admin/system/admin/save',
    method: 'POST',
    data: data
  });
}
export function adminUpdate(pram) {
  var data = {
    account: pram.account,
    phone: pram.phone,
    pwd: pram.pwd,
    roles: pram.roles,
    realName: pram.realName,
    status: pram.status,
    id: pram.id,
    isDel: pram.isDel
  };
  return request({
    url: '/admin/system/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 * @param pram
 */
export function updateStatusApi(params) {
  return request({
    url: "/admin/system/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
export function updateIsSmsApi(params) {
  return request({
    url: "/admin/system/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 权限规则菜单列表
 * @param pram
 */
export function menuListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };
  return request({
    url: "/admin/system/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 权限规则新增菜单
 * @param data
 */
export function menuAdd(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/system/menu/add",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则删除菜单
 * @param data
 */
export function menuDelete(id) {
  return request({
    url: "/admin/system/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 权限规则菜单详情
 * @param data
 */
export function menuInfo(id) {
  return request({
    url: "/admin/system/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 权限规则菜单修改
 * @param data
 */
export function menuUpdate(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/system/menu/update",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param data
 */
export function menuUpdateShowStatus(params) {
  return request({
    url: "/admin/system/menu/updateShowStatus",
    method: 'post',
    params: params
  });
}

//
/**
 * 权限规则菜单详情
 * @param data
 */
export function sensitiveListApi(params) {
  return request({
    url: "/admin/log/sensitive/list",
    method: 'get',
    params: params
  });
}
/**
 * 修改登录用户信息
 * @param data
 */
export function adminNameUpdateApi(data) {
  return request({
    url: "/admin/login/admin/update",
    method: 'post',
    data: data
  });
}
/**
 * 修改登录密码
 * @param data
 */
export function adminPwdUpdateApi(data) {
  return request({
    url: "/admin/login/update/password",
    method: 'post',
    data: data
  });
}